// 페이지 이동 간, 사용자가 입력한 정보를 다시 보여주기 위한 reducer

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

// CollectionInfoType - defined locally since _legacy module was removed
interface CollectionInfoType {
  coll_eng_nm: string;
  coll_kor_nm: string;
  link_nm: string;
  desc: string;
  category: string;
  network: string;
  token_type: string;
  royalty: string;
  web_sns: string;
  discord: string;
  instagram: string;
  medium: string;
  telegram: string;
  etc_sns: string;
}

/**
 * @debt
 * (리팩토링 아이디어)
 * 현재 구조로 reducer 만들면, 새로운 페이지가 생길때 마다 데이터 구조가 복잡해진다.
 * 따라서 임시로 저장 할 데이터를 stringify 하여 string으로 저장해서 사용한다.
 */

interface HasSavedData {
  hasSavedData: boolean;
}

// 리듀서의 상태 구조는 페이지 기준으로 하고, 사용자가 입력한 정보를 갖는다.
export interface TemporaryState {
  create: {
    collection: CreateCollection;
  };
}

interface CreateCollection extends HasSavedData {
  logo_img: File | null;
  rep_img: File | null;
  banner: File | null;
  collEngCheck: boolean;
  collKorCheck: boolean;
  linkNmCheck: boolean;
  collectionInfo: CollectionInfoType;
}

type CreateCollectionPayload = Omit<CreateCollection, 'hasSavedData'>;

const initialState: TemporaryState = {
  create: {
    collection: {
      hasSavedData: false,

      logo_img: null,
      rep_img: null,
      banner: null,
      collEngCheck: false,
      collKorCheck: false,
      linkNmCheck: false,
      collectionInfo: {
        coll_eng_nm: '',
        coll_kor_nm: '',
        link_nm: '',
        desc: '',
        category: '',
        network: 'KAIA',
        token_type: 'KIP17',
        royalty: '0.0',
        web_sns: '',
        discord: '',
        instagram: '',
        medium: '',
        telegram: '',
        etc_sns: '',
      },
    },
  },
};

const temporarySlice = createSlice({
  name: 'temporary',
  initialState,
  reducers: {
    setCreateCollection: (state, action: PayloadAction<CreateCollectionPayload>) => {
      state.create.collection = { ...action.payload, hasSavedData: true };
    },
  },
});

export const temporaryActions = temporarySlice.actions;
export default temporarySlice;
